var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M496,8H16a8,8,0,0,0-8,8V304a8,8,0,0,0,8,8H188.09A71.77,71.77,0,0,0,211,344.21a7.932,7.932,0,0,0,2.52,1.36l-4.18,16.22-66.71,22.23A40.058,40.058,0,0,0,104,423.53L96.84,488H56a8,8,0,0,0,0,16H456a8,8,0,0,0,0-16H415.16L408,423.53a40.058,40.058,0,0,0-38.63-39.51l-66.71-22.23-4.18-16.22a7.932,7.932,0,0,0,2.52-1.36A71.77,71.77,0,0,0,323.91,312H496a8,8,0,0,0,8-8V16A8,8,0,0,0,496,8ZM365.47,399.59A8.074,8.074,0,0,0,368,400a24.032,24.032,0,0,1,24,24,8.652,8.652,0,0,0,.05.88L399.06,488H352V448a8,8,0,0,0-16,0v40H176V448a8,8,0,0,0-16,0v40H112.94l7.01-63.12A8.652,8.652,0,0,0,120,424a24.032,24.032,0,0,1,24-24,8.074,8.074,0,0,0,2.53-.41L217.3,376h77.4ZM312,288a55.754,55.754,0,0,1-19.44,42.4,8,8,0,0,0-12.31,8.57L285.68,360H226.32l5.43-21.03a8,8,0,0,0-12.31-8.57A55.754,55.754,0,0,1,200,288V256a56,56,0,1,1,112,0Zm176,8H327.56a73.257,73.257,0,0,0,.44-8V256a72,72,0,0,0-144,0v32a73.257,73.257,0,0,0,.44,8H24V24H488Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,56H264a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,80H240a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,104h80a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,104H72a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V96A8,8,0,0,0,48,104Zm8-48h8V88H56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,40a72,72,0,1,0,72,72A72.083,72.083,0,0,0,400,40Zm8,16.58A56.11,56.11,0,0,1,455.42,104H408ZM344,112a56.086,56.086,0,0,1,48-55.42v52.11l-36.83,36.83A55.708,55.708,0,0,1,344,112Zm56,56a55.708,55.708,0,0,1-33.52-11.17L403.31,120h52.11A56.086,56.086,0,0,1,400,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,200H376a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,224H376a8,8,0,0,0-5.657,2.343l-28,28a8,8,0,0,0,11.314,11.314L379.314,240H456a8,8,0,0,0,0-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,208V136a8,8,0,0,0-8-8H144a8,8,0,0,0-8,8v72h-8V160a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v48H80V128a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8v80a8,8,0,0,0,0,16H176a8,8,0,0,0,0-16ZM64,208H56V136h8Zm48,0h-8V168h8Zm48,0h-8V144h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,248h84.687l33.656,33.657a8,8,0,1,0,11.314-11.314l-36-36A8,8,0,0,0,128,232H40a8,8,0,0,0,0,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,272H72a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.ab460fab3bbfe7b174debea20b01999b.svg";
export { ForwardRef as ReactComponent };